import { panByScreen } from '../canvas/camera.ts'
import { scene, setCamera } from '../scene/store.ts'
import { startDrag } from '../util/drag.ts'
import type { Tool } from './types.ts'

/** Pan from a pointerdown, used by the pan tool, space-drag and middle-drag. */
export function startPan(e: PointerEvent): void {
  let lastX = e.clientX
  let lastY = e.clientY

  startDrag({
    onMove(ev) {
      setCamera(panByScreen(scene.camera, ev.clientX - lastX, ev.clientY - lastY))
      lastX = ev.clientX
      lastY = ev.clientY
    },
  })
}

export const panTool: Tool = {
  cursor: 'grab',
  onPointerDown(ctx) {
    startPan(ctx.event)
  },
}
